<template>
    <div class="col-md-12">
        <form @submit.prevent="addService">

            <div class="">
                <div class="h2">Add new service</div>
                <div class="">

                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.name=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Service name"
                                                   v-model="service.name">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.description=='' && isSubmit? 'border-danger':''">
                                            <textarea required
                                                      class="form-control form-control border-0 py-0 shadow-none form-input"
                                                      v-model="service.description"
                                                      placeholder="Service description"></textarea>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.type=='' && isSubmit? 'border-danger':''">
                                            <select required class="form-control border-0 py-0 shadow-none pr-5"
                                                    v-model="service.type">
                                                <option value="1">Service</option>
                                                <option value="2">Hourly Service</option>
                                                <option value="3">Warehouse Service</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.price_type=='' && isSubmit? 'border-danger':''">
                                            <select required class="form-control border-0 py-0 shadow-none pr-5"
                                                    v-model="service.price_type">
                                                <option value="1">One time</option>
                                                <option value="2">Hourly service</option>
                                                <option value="3">Daily service</option>
                                                <option value="4">Weekly service</option>
                                                <option value="5">Monthly service</option>
                                                <option value="6">Quarterly service</option>
                                                <option value="7">Yearly service</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "ServiceCreate",
    data() {
        return {
            type: '1',
            price_type: 'one-time',
            service: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addService() {
            let uri = '/services';
            axios.post(uri, this.service).then((response) => {
                window.location.href = `/products`;
            }).catch(err => console.log(err))
        }
    }
}

</script>
